<app-header></app-header>
<app-navigation></app-navigation>
<div class="main-container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
